import VueRouter from 'vue-router';
import Vue from 'vue';
import {Auth} from './class/auth';
import {store} from './store';
import {OrdemServico} from './routers/ordens';
import {Veiculo} from './routers/veiculos';

Vue.use(VueRouter);

let Index = () => import (/* webpackChunkName:"index" */'./pages/Index.vue');
let Login = () => import (/* webpackChunkName:"login" */'./pages/Login.vue');
let LoginToken = () => import (/* webpackChunkName:"login" */'./pages/LoginToken.vue');
let Remember = () => import (/* webpackChunkName:"remember" */'./pages/Remember.vue');
let Acessorios = () => import (/* webpackChunkName: "cadastros/acessorios" */'./pages/cadastros/Acessorios.vue');
let Ibuttons = () => import (/* webpackChunkName: "cadastros/ibuttons" */'./pages/cadastros/Ibuttons');
let ModelosContratos = () => import (/* webpackChunkName: "cadastros/acessorios" */'./pages/cadastros/ModelosContratos');
let AcessoriosAdd = () => import (/* webpackChunkName: "cadastros/acessorio-add" */'./pages/cadastros/AcessoriosAdd.vue');
let Chips = () => import (/* webpackChunkName: "cadastros/chips" */'./pages/cadastros/Chips.vue');
let SensoresTemperatura = () => import (/* webpackChunkName: "cadastros/sensor-temperatura" */'./pages/cadastros/SensoresTemperatura');
let Clientes = () => import (/* webpackChunkName: "cadastros/clientes" */'./pages/cadastros/Clientes.vue');
let Clientes2 = () => import (/* webpackChunkName: "cadastros/clientes" */'./pages/cadastros/Clientes2.vue');
let Cliente = () => import (/* webpackChunkName: "cadastros/cliente" */'./pages/cadastros/Cliente.vue');
let Parceiros = () => import (/* webpackChunkName: "cadastros/parceiros" */'./pages/cadastros/Parceiros');
let ParceiroAdd = () => import (/* webpackChunkName: "cadastros/parceiros-add" */'./pages/cadastros/ParceiroAdd');
let Rastreadores = () => import (/* webpackChunkName: "cadastros/rastreadores" */'./pages/cadastros/Rastreadores.vue');
let RastreadoresDescartados = () => import (/* webpackChunkName: "cadastros/rastreadores-descartados" */'./pages/cadastros/Rastreadoresdescartados.vue');
let Rastreador = () => import (/* webpackChunkName: "cadastros/rastreador" */'./pages/cadastros/Rastreador.vue');
let Chip = () => import (/* webpackChunkName: "cadastros/rastreador" */'./pages/cadastros/Chip.vue');


let VeiculoNovo = () => import (/* webpackChunkName: "cadastros/veiculo-novo" */'./pages/cadastros/VeiculoNovo.vue');
let VeiculoAdd = () => import (/* webpackChunkName: "cadastro/veiculo-add" */ './pages/cadastros/VeiculoAdd.vue');
let Revendas = () => import (/* webpackChunkName: "cadastro/veiculo-add" */ './pages/cadastros/Revendas.vue');
let CercaEletronica = () => import (/* webpackChunkName: "cadastro/cerca-eletronica" */ './pages/cadastros/CercaEletronica.vue');
let CercasEletronicas = () => import (/* webpackChunkName: "cadastro/cercas-eletronicas" */ './pages/cadastros/CercasEletronicas.vue');
let VeiculoTransferir = () => import (/* webpackChunkName: "cadastro/veiculo-transferir" */ './pages/cadastros/VeiculoTransferir.vue');
let DarAcesso = () => import (/* webpackChunkName: "cadastro/dar-acesso" */ './pages/cadastros/DarAcesso');
let Usuarios = () => import (/* webpackChunkName: "cadastro/usuarios" */'./pages/cadastros/Usuarios.vue');
let UsuarioAdd = () => import (/* webpackChunkName: "cadastro/usuario-add" */'./pages/cadastros/UsuarioAdd.vue');
let Rastreamento2 = () => import (/* webpackChunkName: "rastreamento/rastreamento2" */'./pages/rastreamento/Rastreamento2.vue');
let RastreamentoVeiculo = () => import (/* webpackChunkName: "rastreamento/rastreamento2" */'./pages/rastreamento/RastreamentoVeiculo.vue');
let RastreamentoSimples = () => import (/* webpackChunkName: "rastreamento/rastreamento2" */'./pages/rastreamento/RastreamentoSimples.vue');
let RastreamentoCompleto = () => import (/* webpackChunkName: "rastreamento/rastreamento2" */'./pages/rastreamento/RastreamentoCompleto.vue');
let Alertas = () => import (/* webpackChunkName: "rastreamento/alertas" */'./pages/rastreamento/Alertas.vue');
let Configuracao = () => import (/* webpackChunkName: "configuracao" */ './pages/Configuracao.vue');
let SemTransmisao = () => import (/* webpackChunkName: "rastreamento/sem-transmissao" */ './pages/rastreamento/SemTransmisao24Hours.vue');
let GPSTravado = () => import (/* webpackChunkName: "rastreamento/gps-travado" */ './pages/problemas/GPSTravado.vue');
let ChoiceDirection = () => import (/* webpackChunkName: "maps/choice-direction" */ './pages/maps/ChoiceDirection.vue');
let AllMaps = () => import (/* webpackChunkName: "maps/all" */ './pages/rastreamento/AllMaps.vue');
let MapsRastreamento = () => import (/* webpackChunkName: "maps/rastreamento" */ './pages/rastreamento/MapsRastreamento');
let UpdatePassword = () => import (/* webpackChunkName: "atualizar-senha" */ './pages/UpdatePassword.vue');
let Eventos = () => import (/* webpackChunkName: "eventos" */ './pages/Eventos');

let VeiculosSemCobranca = () => import (/* webpackChunkName: "relatorios/veiculos-sem-cobranca" */
    './pages/financeiro/VeiculosSemCobranca');

// FINANCEIRO
let PrognosticoFinanceiro = () => import (/* webpackChunkName: "prognostico-financeiro" */
    './pages/financeiro/PrognosticoFinanceiro');
let NotasMensais = () => import (/* webpackChunkName: "notas-mensais" */
    './pages/financeiro/NotasMensais.vue');

let Calendario = () => import (/* webpackChunkName: "prognostico-financeiro" */
    './pages/financeiro/CalendarioPage.vue');

// PROBLEMAS
let ClientesSemAcesso30Dias = () => import (/* webpackChunkName: "problemas/clientes-sem-acessos" */ './pages/problemas/ClientesSemAcesso30Dias');
let Oficina = () => import (/* webpackChunkName: "problemas/oficina" */ './pages/problemas/Oficina');
let Roubado = () => import (/* webpackChunkName: "problemas/oficina" */ './pages/problemas/Roubado');
let Manutencao = () => import (/* webpackChunkName: "problemas/manutencao" */ './pages/problemas/Manutencao');
let BoletosVencidos = () => import (/* webpackChunkName: "relatorios/boletos-vencidos" */ './pages/financeiro/BoletosVencidos');
let BoletosPagos = () => import (/* webpackChunkName: "relatorios/boletos-pagos" */ './pages/financeiro/BoletosPagos');
let BoletosMensais = () => import (/* webpackChunkName: "relatorios/boletos-mensais" */ './pages/financeiro/BoletosMensais');
let BoletosNaoRegistrados = () => import (/* webpackChunkName: "relatorios/boletos-nao-registrados" */
    './pages/financeiro/BoletosNaoRegistrados');

let ClienteSemCobranca = () => import (/* webpackChunkName: "relatorios/cliente-sem-cobranca" */ './pages/financeiro/ClienteSemCobranca');
let BoletosRastreamos = () => import (/* webpackChunkName: "boletos-rastreamos" */ './pages/BoletosRastreamos');
let Block = () => import (/* webpackChunkName: "block-rastreamos" */ './pages/Block.vue');

// RELATORIOS
let Logs = () => import (/* webpackChunkName: "block-rastreamos" */ './pages/relatorios/Logs.vue');
let PeriodoMapa = () => import (/* webpackChunkName: "block-rastreamos" */ './pages/relatorios/PeriodoMapa.vue');

// PRINCIPAIS
let Financeiro = () => import (/* webpackChunkName: "financeiro" */
    './pages/Financeiro.vue');

/**
 * Sem next() o Vue Router cancela a navegação e a tela fica branca.
 * Falha de rede (ERR_CONNECTION_REFUSED, timeout) não tem e.response.
 */
let handleAuthGuardError = (e, next, from) => {
    if (e.response) {
        if (e.response.status === 401) {
            window.localStorage.clear();
            return next({path: '/login'});
        }
        if (e.response.status === 423) {
            return next({path: '/block'});
        }
    }

    // Já está na tela de API offline: aborta em vez de redirecionar de novo
    if (from && from.path === '/login' && from.query.api === 'offline') {
        return next(false);
    }

    return next({path: '/login', query: {api: 'offline'}});
};

let checkAuth = (to, from, next) => {
    if (!window.localStorage.getItem('token')){
        return next({path: '/login'});
    }

    Auth.isAuth()
        .then(() => {
            store.commit('setAuth', true);
            next();
        })
        .catch((e) => handleAuthGuardError(e, next, from));
};

let checkFinanceiro = (to, from, next) => {
    if (!window.localStorage.getItem('token')){
        return next({path: '/login'});
    }
    Auth.me()
        .then((data) => {
            if (! data.acesso_financeiro && ! data.admin) {
                return next({path: '/'});
            }
            store.commit('setAuth', true);
            next();
        })
        .catch((e) => handleAuthGuardError(e, next, from));
};

let checkBlock = (to, from, next) => {
    if (!window.localStorage.getItem('token')){
        return next({path: '/login'});
    }
    Auth.isAuth()
        .then(() => {
            store.commit('setAuth', true);
            next();
        })
        .catch((e) => handleAuthGuardError(e, next, from));
};

const routes = [
    { path: '*', component: Index, beforeEnter: checkAuth},
    { path: '/', component: Index, beforeEnter: checkAuth},
    { path: '/boletos-rastreamos', component: BoletosRastreamos, beforeEnter: checkAuth},
    { path: '/block', component: Block, beforeEnter: checkBlock},
    { path: '/periodo-mapa', component: PeriodoMapa, beforeEnter: checkAuth},
    { path: '/acessorios', component: Acessorios, beforeEnter: checkAuth},
    { path: '/revendas', component: Revendas, beforeEnter: checkAuth},
    { path: '/ibuttons', component: Ibuttons, beforeEnter: checkAuth},
    { path: '/acessorio/:id_acessorio', component: AcessoriosAdd, beforeEnter: checkAuth},
    { path: '/acessorio', component: AcessoriosAdd, beforeEnter: checkAuth},
    { path: '/chips', component: Chips, beforeEnter: checkAuth},
    { path: '/chip', component: Chip, beforeEnter: checkAuth},
    { path: '/chip/:id', component: Chip, beforeEnter: checkAuth},
    { path: '/parceiros', component: Parceiros, beforeEnter: checkAuth},
    { path: '/parceiro/:id', component: ParceiroAdd, beforeEnter: checkAuth},
    { path: '/parceiro', component: ParceiroAdd, beforeEnter: checkAuth},
    { path: '/modelos-contratos', component: ModelosContratos, beforeEnter: checkAuth},
    { path: '/sensores-temperatura', component: SensoresTemperatura, beforeEnter: checkAuth},
    { path: '/clientes2', component: Clientes2, beforeEnter: checkAuth},
    { path: '/clientes', component: Clientes2, beforeEnter: checkAuth},
    { path: '/cliente/:id', component: Cliente, beforeEnter: checkAuth},
    { path: '/cliente', component: Cliente, beforeEnter: checkAuth},
    { path: '/cerca-eletronica', component: CercaEletronica, beforeEnter: checkAuth},
    { path: '/cerca-eletronica/:id', component: CercaEletronica, beforeEnter: checkAuth},
    { path: '/cercas-eletronicas', component: CercasEletronicas, beforeEnter: checkAuth},
    { path: '/rastreadores', component: Rastreadores, beforeEnter: checkAuth},
    { path: '/rastreadores-descartados', component: RastreadoresDescartados, beforeEnter: checkAuth},
    { path: '/rastreador', component: Rastreador, beforeEnter: checkAuth},
    { path: '/rastreador/:id', component: Rastreador, beforeEnter: checkAuth},
    { path: '/usuarios', component: Usuarios, beforeEnter: checkAuth},
    { path: '/usuario', component: UsuarioAdd, beforeEnter: checkAuth},
    { path: '/usuario/:id_usuario', component: UsuarioAdd, beforeEnter: checkAuth},

    { path: '/rastreamento', component: Rastreamento2, beforeEnter: checkAuth},
    { path: '/rastreamento-simples', component: RastreamentoSimples, beforeEnter: checkAuth},
    { path: '/rastreamento-veiculos', component: RastreamentoVeiculo, beforeEnter: checkAuth},
    { path: '/rastreamento-completo', component: RastreamentoCompleto, beforeEnter: checkAuth},

    // Veiculos
    { path: '/veiculos', component: Veiculo.List, beforeEnter: checkAuth},
    { path: '/veiculos-cancelados', component: Veiculo.ListCancelados, beforeEnter: checkAuth},
    { path: '/veiculo', component: VeiculoNovo, beforeEnter: checkAuth},
    { path: '/veiculo/novo/:uuid_cliente', component: VeiculoAdd, beforeEnter: checkAuth},
    { path: '/veiculo/transferir/:id_veiculo', component: VeiculoTransferir, beforeEnter: checkAuth},
    { path: '/veiculo/dar-acesso/:id_veiculo', component: DarAcesso, beforeEnter: checkAuth},
    { path: '/veiculo/:id_veiculo', component: VeiculoAdd, beforeEnter: checkAuth},

    { path: '/alertas', component: Alertas, beforeEnter: checkAuth},
    { path: '/login', component: Login },
    { path: '/login/token/:token/:username', component: LoginToken },
    { path: '/remember', component: Remember },

    // ORDEM DE SERVICO
    { path: '/ordens-servicos', component: OrdemServico.List, beforeEnter: checkAuth},
    { path: '/ordens-servicos/novo/:id_veiculo', component: OrdemServico.New, beforeEnter: checkAuth},
    { path: '/ordens-servicos/:id', component: OrdemServico.New, beforeEnter: checkAuth},


    { path: '/config', component: Configuracao, beforeEnter: checkAuth},
    { path: '/direction', component: ChoiceDirection, beforeEnter: checkAuth},
    { path: '/all-maps', component: AllMaps, beforeEnter: checkAuth},
    { path: '/maps-rastreamento', component: MapsRastreamento, beforeEnter: checkAuth},
    { path: '/update-password', component: UpdatePassword, beforeEnter: checkAuth},
    { path: '/eventos', component: Eventos, beforeEnter: checkAuth},
    { path: '/problemas/oficina', component: Oficina, beforeEnter: checkAuth},
    { path: '/problemas/roubados', component: Roubado, beforeEnter: checkAuth},
    { path: '/problemas/manutencao', component: Manutencao, beforeEnter: checkAuth},
    { path: '/problemas/gps-travado', component: GPSTravado, beforeEnter: checkAuth},
    { path: '/problemas/30dias', component: ClientesSemAcesso30Dias, beforeEnter: checkAuth},
    { path: '/problemas/sem-transmissao', component: SemTransmisao, beforeEnter: checkAuth},
    { path: '/relatorios/logs', component: Logs, beforeEnter: checkAuth},

    // financeiro
    {
        path: '/financeiro',
        component: Financeiro,
        beforeEnter: checkFinanceiro,
        children: [
            {
                path: 'boletos-nao-registrados',
                component: BoletosNaoRegistrados,
            },
            {
                path: 'notas-mensais',
                component: NotasMensais,
            },
            {
                path: 'boletos-vencidos',
                component: BoletosVencidos,
            },
            {
                path: 'boletos-mensais',
                component: BoletosMensais,
            },
            {
                path: 'boletos-pagos',
                component: BoletosPagos,
            },
            {
                path: 'cliente-sem-cobranca',
                component: ClienteSemCobranca,
            },
            {
                path: 'prognostico-financeiro',
                component: PrognosticoFinanceiro,
            },
            {
                path: 'veiculos-sem-cobranca',
                component: VeiculosSemCobranca,
            }
        ],
    }
];

export const router = new VueRouter({
    routes // short for routes: routes
});
